var productVariants;
var isEnterprise;
var markPercent;
var markEnabled;
var markTrigger;
var gangEnabled;
var defaultRatePerSqin;
var gangRatePerSqin;
var imagePadding;
var defaultPrintType;
var lockDefaultPrintType;

var useMarkets = true;

var BentoSMB = {
    global: {
        min: {
            width: 0.1,
            height: 0.1,
        },
        max: {
            width: 22
        },
    },
    fileOrder: [],
    customPricingMap: [[4, 0.16], [8, 0.32], [9, 0.34], [15, 0.58], [16, 0.65], [24, 0.97], [25, 0.96], [36, 1.09], [49, 1.68], [55, 2.12], [56, 2.05], [64, 2.49], [81, 1.84], [99, 2.29], [100, 2.57], [121, 3.42], [144, 5.33], [154, 3.88], [204, 5.84]],
    variantOptions: null,
    imageDefaults: null,
    elements: null,
    state: 'unset',
    reader: new FileReader(),
    redirect: false,
    update: () => {
        let dimensionEls;
        switch(BentoSMB.state) {
            case 'unset':
                BentoSMB.elements.style.innerHTML = `
                    product-info div#custom-size-fields,
                    product-info variant-radios,
                    product-info variant-selects,
                    product-info form div#bcpo,
                    product-info div.cl-upload--input-fields,
                    div.price__container div.price__regular {
                        display: none;
                    }
                `;
                break;
            case 'custom':
                // Enable custom dimension inputs
                dimensionEls = document.querySelectorAll('#custom-size-fields .quantity > input');
                for (const element of dimensionEls) {
                    if (element.hasAttribute('disabled') === true) {
                        element.removeAttribute('disabled');
                    }
                }

                // Disabled preset dimension inputs
                dimensionEls = document.querySelectorAll('#custom-size-fields input[data-preset]');
                for (const element of dimensionEls) {
                    element.setAttribute('disabled', '');
                }

                BentoSMB.elements.style.innerHTML = `
                    product-info div#custom-size-fields ~ div > product-form div#bcpo div[data-unique]:first-of-type,
                    product-info div#custom-size-fields ~ variant-radios > fieldset:first-of-type,
                    product-info div#custom-size-fields ~ variant-selects > fieldset:first-of-type {
                        opacity: 0.3;
                    }
                `;
                BentoSMB.selectVariantBySize();
                break;
            case 'preset':
                // Disabled custom dimension inputs
                dimensionEls = document.querySelectorAll('#custom-size-fields .quantity > input');
                for (const element of dimensionEls) {
                    element.setAttribute('disabled', '');
                }

                // Enable preset dimension inputs
                dimensionEls = document.querySelectorAll('#custom-size-fields input[data-preset]');
                for (const element of dimensionEls) {
                    if (element.hasAttribute('disabled') === true) {
                        element.removeAttribute('disabled');
                    }
                }

                BentoSMB.elements.style.innerHTML = `
                    product-info div#custom-size-fields > div.wrapper {
                        opacity: 0.3;
                    }
                `;

                const selectedEl = document.querySelector('#bcpo-select-option-0 > div:not([hidden]) > input[type="radio"]:checked, variant-radios > fieldset:first-of-type > input[type="radio"]:not([hidden]):checked, variant-selects > fieldset:first-of-type > input[type="radio"]:not([hidden]):checked');
                if (selectedEl === null) {
                    const selectEl = document.querySelector('#bcpo-select-option-0 > div:not([hidden]) > input[type="radio"], variant-radios > fieldset:first-of-type > input[type="radio"]:not([hidden]), variant-selects > fieldset:first-of-type > input[type="radio"]:not([hidden])');
                    selectEl.click();
                }

                break;
        }
    },
    getElements: () => {
        // Not product page, do not proceed
        if (isEnterprise === undefined) return;

        BentoSMB.elements = {
            style: document.querySelector('style#custom-styles'),
            customSizeFields: document.querySelector('div#custom-size-fields'),
            addToCart: document.querySelector('form button[type="submit"]'),
        };
    },
    element: {
        inputError: (message, _removeAfter = null) => {
            const el = document.createElement('div');
            el.innerHTML = `
              <p class="error">${message}</p>
            `;

            if (typeof _removeAfter === 'number') {
              setTimeout(() => el.remove(), _removeAfter);
            }

            return el;
        },
        headerSection: (file, fileID) => {
            const fileName = file.filename;
          
            const el = document.createElement('div');
            el.setAttribute('data-file-id', fileID);
            el.setAttribute('class', 'file-section-header');
            el.innerHTML = `
                <div>
                    <p style="margin: 0;">${fileName}</p>
                    <p data-detected-size style="margin: 0;font-weight: 400;font-size: 0.8em;"></p>
                </div>
            `;

            const imageCanvasEl = document.querySelector(`li#filepond--item-${fileID} .filepond--image-bitmap > canvas`);
            const newCanvas = document.createElement('canvas');
            const context = newCanvas.getContext('2d');

            newCanvas.width = imageCanvasEl.width;
            newCanvas.height = imageCanvasEl.height;

            context.drawImage(imageCanvasEl, 0, 0);

            el.prepend(newCanvas);

            return el;
        },
        quantityInput: (id, fileID, options = {}) => {
            const min = options.min || BentoSMB.global.min[id];
            const max = options.max || BentoSMB.global.max[id];

            const el = document.createElement('input');
            el.setAttribute("class", "dimensions__input");
            el.setAttribute("data-file-id", fileID);
            el.setAttribute('type', 'number');
            el.id = id;
            el.name = `properties[${id}-${fileID}]`;
            el.value = 1;
            el.setAttribute('data-min', min);
            el.setAttribute('min', min);
            el.setAttribute('step', options.step || '0.01');
            el.setAttribute('max', max);
            el.setAttribute('form', BentoSMB.form.getAttribute('id'));

            el.addEventListener('change', (event) => {
                const value = event.target.value;
                if (min) {
                    const buttonMinus = document.querySelector(`.quantity__button[name='minus'][data-id='${id}']${fileID ? `[data-file-id="${fileID}"]` : ''}`);
                    buttonMinus.classList.toggle('disabled', value <= min);
                    if (value < min) event.target.value = min;
                }
                
                if (max) {
                    const buttonPlus = document.querySelector(`.quantity__button[name='plus'][data-id='${id}']${fileID ? `[data-file-id="${fileID}"]` : ''}`);
                    buttonPlus.classList.toggle('disabled', value >= max);
                    if (value > max) event.target.value = max;
                }
            });

            return el;
        },
        quantityButton: (id, method, fileID) => {
            const el = document.createElement('button');
            el.setAttribute("class", "quantity__button no-js-hidden");
            el.setAttribute("data-file-id", fileID);
            el.setAttribute("data-id", id);
            el.name = method;
            el.setAttribute('type', 'button');
            
            if (method === 'minus') {
                el.innerHTML = `
                    <span class="visually-hidden">Decrease ${id} for custom size in inches</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                        </path>
                    </svg>
                `;
            } else if (method === 'plus') {
                el.innerHTML = `
                    <span class="visually-hidden">Increase ${id} for custom size in inches</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                        </path>
                    </svg>
                `;
            }

            el.addEventListener('click', (event) => {
                event.preventDefault();
                const input = document.querySelector(`input[id="${id}"]${fileID ? `[data-file-id="${fileID}"]` : ''}`);
                const previousValue = document.querySelector(`input[id="${id}"]${fileID ? `[data-file-id="${fileID}"]` : ''}`).value;
            
                event.target.name === 'plus' ? input.stepUp() : input.stepDown();
                if (previousValue !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
            });

            return el;
        },
        dimensionSection: (fileID) => {
            const el = document.createElement('div');
            el.setAttribute("data-file-id", fileID);
            el.setAttribute("class", "wrapper");
            el.innerHTML = `
                <div>
                    <p>Width (inches)</p>
                    <div class="quantity" name="width"></div>
                </div>
                <div>
                    <p>Height (inches)</p>
                    <div class="quantity" name="height"></div>
                </div>
            `;

            const widthMinusBtnEl = BentoSMB.element.quantityButton('width', 'minus', fileID);
            const widthInputEl = BentoSMB.element.quantityInput('width', fileID);
            const widthPlusBtnEl = BentoSMB.element.quantityButton('width', 'plus', fileID);

            el.children[0].children.width.append(widthMinusBtnEl, widthInputEl, widthPlusBtnEl);

            const heightMinusBtnEl = BentoSMB.element.quantityButton('height', 'minus', fileID);
            const heightInputEl = BentoSMB.element.quantityInput('height', fileID);
            const heightPlusBtnEl = BentoSMB.element.quantityButton('height', 'plus', fileID);

            el.children[1].children.height.append(heightMinusBtnEl, heightInputEl, heightPlusBtnEl);

            return el;
        },
        quantitySection: (fileID) => {
            const el = document.createElement('div');
            el.setAttribute("data-file-id", fileID);
            el.innerHTML = `
                <p>Quantity</p>
                <div name="quantity" class="quantity"></div>
            `;

            const quantityMinusBtnEl = BentoSMB.element.quantityButton('quantity', 'minus', fileID);
            const quantityInputEl = BentoSMB.element.quantityInput('quantity', fileID, {step: 1, min: 1, max: null, });
            const quantityPlusBtnEl = BentoSMB.element.quantityButton('quantity', 'plus', fileID);

            el.children.quantity.append(quantityMinusBtnEl, quantityInputEl, quantityPlusBtnEl);

            return el;
        },
        formatSection: (fileID) => {
            const el = document.createElement('div');
            el.setAttribute("data-file-id", fileID);
            el.innerHTML = `
                <p>Print Method</p>
                <div class="print-method-wrapper">
                  <label for="dtf-${fileID}">
                    <input type="radio" checked id="dtf-${fileID}" value="DTF" form="${BentoSMB.form.getAttribute('id')}" data-file-id="${fileID}" data-print-method />
                    <div>
                      DTF
                    </div>
                  </label>
                  <label for="uv-dtf-${fileID}">
                    <input type="radio" id="uv-dtf-${fileID}" value="UV-DTF" form="${BentoSMB.form.getAttribute('id')}" data-file-id="${fileID}" data-print-method />
                    <div>
                      UV-DTF
                    </div>
                  </label>
                </div>
            `;

            return el;
        },
    },
    listen: () => {
        // Not product page, do not proceed
        if (isEnterprise === undefined) return;

        BentoSMB.listenToFileUpload();
        if (isEnterprise === false) {
            BentoSMB.listenToCustomSizeInputs();
        }
        BentoSMB.listenToForm();
    },
    listenToFormatInputs: (fileID) => {
        const inputEls = document.querySelectorAll(`div#custom-size-fields input[data-print-method][type="radio"]${fileID ? `[data-file-id="${fileID}"]` : ''}`);
        inputEls.forEach((el) => {
            el.addEventListener('change', () => {          
                BentoSMB.calculatePricing();
            });
        });
    },
    listenToCustomSizeInputs: (fileID) => {
        const inputEls = document.querySelectorAll(`div#custom-size-fields input[type="number"]${fileID ? `[data-file-id="${fileID}"]` : ''}:not(#quantity)`);
        inputEls.forEach((el) => {
          el.addEventListener('change', BentoSMB.maintainAspectRatio.bind(this, fileID));

          const id = el.getAttribute('id');
          const min = BentoSMB.global.min[id];
          const max = BentoSMB.global.max[id];
          
          el.setAttribute('data-min', min);
          el.setAttribute('min', min);
          el.setAttribute('step', '0.01');
          el.setAttribute('max', max);
        });

        BentoSMB.mapCustomSizeOptions();
        
        if (template === 'product.enterprise-submission' || template === 'product.enterprise-submission-uv-dtf') {
            // const quantityEl = document.querySelector(`quantity-input.quantity input.quantity__input`);
            const quantityEl = document.querySelector(`div#custom-size-fields input[type="number"][data-file-id="${fileID}"]#quantity`);
            quantityEl.addEventListener('change', BentoSMB.calculatePricing.bind(this));
        } else {
            const radioEls = document.querySelectorAll(`div#custom-size-fields input[type="radio"]`);
            radioEls.forEach((el) => el.addEventListener('change', BentoSMB.updateProductFormScene.bind(this)));
        }

        if (isEnterprise === false) {
            const buttonEls = document.querySelectorAll(`div#custom-size-fields button${fileID ? `[data-file-id="${fileID}"]` : ''}`);
            buttonEls.forEach((el) => el.addEventListener('click', (event) => {
                const target = event.target;
    
                const input = target.parentNode.children[1];
                if (target.name === 'plus') {
                    input.stepUp();
                } else if (target.name = 'minus') {
                    input.stepDown();
                }
    
                input.dispatchEvent(new Event('change'));
    
                if (BentoSMB.state === 'custom') return;
                document.querySelector('div#custom-size-fields input[type="radio"][value="custom"]')?.click();
            }));
        }
    },
    listenToFileUpload: () => {
        document.addEventListener('FilePond:init', () => {
            BentoSMB.state = 'unset';
            BentoSMB.update();
        });

        document.addEventListener('FilePond:addfilestart', (event) => {
            const fileID = event.detail.file.id;
            BentoSMB.fileOrder.push(fileID);
        });
        
        document.addEventListener('FilePond:removefile', (event) => {
            let fileID;
            if (isEnterprise) {
                fileID = event.detail.file.id;

                const els = document.querySelectorAll(`div[data-file-id="${fileID}"]`);
                els.forEach(el => el.remove());
                BentoSMB.fileOrder = BentoSMB.fileOrder.filter(id => id !== fileID);
    
                BentoSMB.indexCustomOptions();
                BentoSMB.calculatePricing();

                if (document.querySelectorAll('div.wrapper').length === 0) {
                    BentoSMB.state = 'unset';
                }
            } else {
                BentoSMB.state = 'unset';
            }

            BentoSMB.update();
        });

        document.addEventListener('FilePond:preparefile', (event) => {
            let fileID;
            if (isEnterprise) {
                fileID = event.detail.file.id;
            }

            if (isEnterprise) {
                // QuickFix: Client has utilized enterprise for non-enterprise products
                if (product.handle === 'auto-gang' || product.handle === 'auto-gang-uv-dtf') {
                  BentoSMB.elements.customSizeFields.prepend(BentoSMB.element.dimensionSection(fileID), BentoSMB.element.quantitySection(fileID));
                } else {
                  BentoSMB.elements.customSizeFields.prepend(BentoSMB.element.dimensionSection(fileID), BentoSMB.element.quantitySection(fileID), BentoSMB.element.formatSection(fileID));
                }
                BentoSMB.elements.customSizeFields.prepend(BentoSMB.element.headerSection(event.detail.file, fileID))
                BentoSMB.listenToCustomSizeInputs(fileID);
                BentoSMB.listenToFormatInputs(fileID);

                BentoSMB.indexCustomOptions();
            }

            const {file} = event.detail.output.find((item) => item.name === 'original');
            BentoSMB.getFileDetails(file, fileID);
            BentoSMB.state = 'custom';
            BentoSMB.update();
        });
    },
    indexCustomOptions: () => {
        const els = document.querySelectorAll('#custom-size-fields > .wrapper');
        els.forEach(item => {
            const inputs = item.querySelectorAll('input');
            const id = item.getAttribute('data-file-id');
            const index = BentoSMB.fileOrder.findIndex(element => element === id);

            inputs.forEach(input => input.name = `properties[upload_${index + 1}_${input.getAttribute('id')}]`);

            const quantity = document.querySelector(`input#quantity[data-file-id="${id}"]`);

            if (quantity) {
                quantity.name = `properties[upload_${index + 1}_quantity]`;
            }

            const printMethods = document.querySelectorAll(`input[data-print-method][data-file-id="${id}"]`);

            printMethods.forEach(input => input.name = `properties[upload_${index + 1}_print_method]`);
        });
    },
    listenToForm: () => {
        BentoSMB.form = document.querySelector('form.form[id^="product-form-template--"]');
        // BentoSMB.form.addEventListener('submit', BentoSMB.reset.bind(this));
    },
    mapCustomSizeOptions: () => {
        if (template === 'product.enterprise-submission' || template === 'product.enterprise-submission-uv-dtf') return;
        BentoSMB.variantOptions = productVariants
            .filter((variant) => variant.option1.includes('Style #') && variant.option2.includes('Yes -'))
            .map((variant) => {
                const [min, max] = variant.option1.replace('Style #', '').split('-');
                return [Number(min), Number(max), variant.option1];
            });

        document.addEventListener('FilePond:init', () => {
            BentoSMB.hideCustomSizeOptions();
            BentoSMB.listenPresetSizeOptions();
        });
    },
    listenPresetSizeOptions: () => {
        const optionEls = document.querySelectorAll('#bcpo-select-option-0 > div:not([hidden]) > input[type="radio"], variant-radios > fieldset:first-of-type > input[type="radio"]:not([hidden]), variant-selects > fieldset:first-of-type > input[type="radio"]:not([hidden])');
        optionEls.forEach((el) => el.addEventListener('click', (event) => {
            const {target} = event;

            const el = document.querySelector('div#custom-size-fields label:nth-of-type(2) > input');
            if (el.checked === false) {
                el.click();
            }

            // Update size inputs for presets
            try {
                const values = target.value.replace(/(\"|\”)/gi, '').replace(/ /gi, '').toLowerCase().split('x');
                document.querySelector('input#width[data-preset]').value = values[0];
                document.querySelector('input#height[data-preset]').value = values[1];
            } catch {}
        }));
    },
    hideCustomSizeOptions: () => {
        const style = document.createElement('style');
        style.innerHTML = ``;
        BentoSMB.variantOptions.forEach(([,,value]) => {
            style.innerHTML += `
                form #bcpo .bcpo-buttons input[value="${value}"] + label.bcpo-front-button-label,
                variant-radios input[value="${value}"] + label,
                variant-selects input[value="${value}"] + label { 
                    display: none !important;
                }
            `;

            let optionEl = document.querySelector(`form #bcpo .bcpo-buttons input[value="${value}"] + label.bcpo-front-button-label`);
            if (optionEl === null) {
                optionEl = document.querySelector(`variant-radios input[value="${value}"], variant-selects input[value="${value}"]`);
                optionEl.setAttribute('hidden', '');
                optionEl = document.querySelector(`variant-radios input[value="${value}"] + label, variant-selects input[value="${value}"] + label`);
                optionEl.setAttribute('hidden', '');
            } else {
                optionEl.parentNode.setAttribute('hidden', '');
            }
        });

        document.body.append(style);
    },
    getFileDetails: (file, fileID) => {
        BentoSMB.reader.readAsDataURL(file);
        BentoSMB.reader.onload = (e) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = () => {
                let { height, width } = image;
                height = BentoSMB.convertPixelToInches(height);
                width = BentoSMB.convertPixelToInches(width);
                
                const aspectRatio = BentoSMB.getAspectRatio(image);

                if (isEnterprise) {
                    if (BentoSMB.imageDefaults === null) {
                        BentoSMB.imageDefaults = {[fileID]: {height, width, aspectRatio}};
                    } else {
                        BentoSMB.imageDefaults[fileID] = {height, width, aspectRatio};
                    }

                    // Set detected size label in header
                    const detectedSizeEl = document.querySelector(`[data-file-id="${fileID}"] [data-detected-size]`);
                    detectedSizeEl.innerHTML = `Detected size: ${width}" x ${height}"`;
                } else {
                    BentoSMB.imageDefaults = {height, width, aspectRatio};
                }
              
                const heightInputEl = document.querySelector(`div#custom-size-fields input#height${fileID ? `[data-file-id="${fileID}"]` : ''}`);
                heightInputEl.value = height;

                const widthInputEl = document.querySelector(`div#custom-size-fields input#width${fileID ? `[data-file-id="${fileID}"]` : ''}`);
                widthInputEl.value = width;

                if (width > BentoSMB.global.max.width) {
                    widthInputEl.parentNode.parentNode.append(BentoSMB.element.inputError('Max size of 22 inches', 5000));
                    heightInputEl.parentNode.parentNode.append(BentoSMB.element.inputError('Max size of 22 inches', 5000));
                    widthInputEl.dispatchEvent(new Event('change'));
                }

                if (template === 'product.enterprise-submission' || template === 'product.enterprise-submission-uv-dtf') {
                    BentoSMB.calculatePricing();
                } else {
                    document.querySelector('div#custom-size-fields span#size').innerHTML = `${width}" x ${height}"`;
    
                    BentoSMB.selectVariantBySize();
                }
            };
        };
    },
    convertPixelToInches: (value) => {
        // 300 Pixels per inch
        return Math.round((Number(value) / 300) * 100) / 100;
    },
    attempt: (func, attempts = 0, _max_attempts = 10, _delay = 500) => {
        try {
            func();
        } catch (err) {
            console.error(err);

            if (attempts >= _max_attempts) return;
            setTimeout(BentoSMB.attempt.bind(this, func, attempts + 1, _max_attempts, _delay), _delay);
        }
    },
    getAspectRatio: (image) => {
        const w = image.naturalWidth;
        const h = image.naturalHeight;

        return w / h;
    },
    calculatePricing: () => {
        const quantities = document.querySelectorAll('div#custom-size-fields input#quantity');
        const widths = document.querySelectorAll('div#custom-size-fields input#width');
        const heights = document.querySelectorAll('div#custom-size-fields input#height');
        const formats = document.querySelectorAll('div#custom-size-fields input[data-print-method]:checked');

        const prices = [];
        for (let i = 0; i < widths.length; i++) {
            let width = widths[i].value;
            let height = heights[i].value;
            let printType = formats[i]?.value || defaultPrintType;

            if (lockDefaultPrintType === true) {
                printType = defaultPrintType;
            } else if (typeof printType === 'string') {
                printType = printType.replace('-', '').toLowerCase();
            }

          console.log({lockDefaultPrintType, printType, defaultPrintType})

            if (isEnterprise === true) {
                width = Number(width) + (imagePadding[printType] * 2);
                height = Number(height) + (imagePadding[printType] * 2);
            }

            const quantity = quantities[i].value;
            const fileId = quantities[i].dataset.fileId;
            const imageDefault = BentoSMB.imageDefaults[fileId];

            let squaredInches = width * height;
            let price = Math.ceil(squaredInches * defaultRatePerSqin[printType] * 100);
            if (gangEnabled[printType] === true && imageDefault.height > 20 && imageDefault.width > 20) {
                squaredInches = 22 * height;
                price = Math.ceil(squaredInches * gangRatePerSqin[printType] * 100)
            } else if (markEnabled[printType] === true && squaredInches >= markTrigger[printType]) {
                price = Math.ceil(price * (1.0 + markPercent[printType]));
            }

            price *= quantity;
            
            prices.push(price);
        }

        let price = prices.reduce((acc, curr) => acc + curr, 0);

        // let unitPrice = 0;
        // if (BentoSMB.state === 'unset') {
        //     unitPrice = 0;
        // } else {
        //     // const selectPricing = BentoSMB.customPricingMap
        //     //     .find((option) => option[0] >= squaredInches)
        //     //     ?.[1];
            
        //     unitPrice = selectPricing * 100;
        // }
        // document.querySelector('input#unit-price').value = unitPrice;
        // const price = quantity * unitPrice;

        document.querySelector('input#unit-price').value = price;
        const priceEl = document.querySelector('div.price__container span.price-item');
        // priceEl.innerHTML = `
        //     ${bcpo.formatMoney(price, '${{ amount }}')}
        //     ${quantity > 1 && unitPrice > 0 ? `<span>${bcpo.formatMoney(unitPrice, '${{ amount }}')} ea</span>` : ''}
        // `;

        if (useMarkets === true && Shopify.country !== 'US') {
            // Apply logic for market currency conversion
            price = Math.ceil(Number(Shopify.currency.rate) * Number(price / 100)) * 100;
        }

        priceEl.innerHTML = `
            ${bcpo.formatMoney(price, '${{ amount }}')}
        `;
    },
    selectVariantBySize: () => {
        if (template === 'product.enterprise-submission' || template === 'product.enterprise-submission-uv-dtf') return false;

        const width = Number(document.querySelector('div#custom-size-fields input#width').value);
        const height = Number(document.querySelector('div#custom-size-fields input#height').value);
        const squaredInches = Math.ceil(width * height);

        const sizeToSelect = BentoSMB.variantOptions
            .find((option) => option[1] >= squaredInches && option[0] <= squaredInches)
            ?.[2];

        try {
            document.querySelector(`input[value="${sizeToSelect}"]`).click();
        } catch {}

        return true;
    },
    maintainAspectRatio: (fileID, event) => {
        const target = event.target;
        let value = Number(target.value);

        if (isEnterprise === false) {
            const min = Number(target.getAttribute('min'));
            const max = Number(target.getAttribute('max'));

            if (value > max) {
                value = max;
                target.value = max;
            } else if (value < min) {
                value = min;
                target.value = min;
            }
        }

        let aspectRatio;
        if (isEnterprise === true) {
            aspectRatio = BentoSMB.imageDefaults[fileID].aspectRatio;
        } else {
            aspectRatio = BentoSMB.imageDefaults.aspectRatio;
        }

        let pairEl, newValue;
        if (target.id === 'width') {
            pairEl = document.querySelector(`div#custom-size-fields input#height${fileID ? `[data-file-id="${fileID}"]` : ''}`);
            newValue = Math.round((value / aspectRatio) * 100) / 100;
        } else if (target.id === 'height') {
            pairEl = document.querySelector(`div#custom-size-fields input#width${fileID ? `[data-file-id="${fileID}"]` : ''}`);
            newValue = Math.round((value * aspectRatio) * 100) / 100;
        }

        const pairMin = Number(pairEl.getAttribute('min'));
        const pairMax = Number(pairEl.getAttribute('max'));

        if (typeof pairMin === 'number' && pairMin > newValue) {
            pairEl.value = pairMin;
            if (pairEl.id === 'width') {
                target.value = Math.round((pairMin / aspectRatio) * 100) / 100;
            } else if (pairEl.id === 'height') {
                target.value = Math.round((pairMin * aspectRatio) * 100) / 100;
            }
        } else if (typeof pairMax === 'number' && pairMax < newValue) {
            pairEl.value = pairMax;
            if (pairEl.id === 'width') {
                target.value = Math.round((pairMax / aspectRatio) * 100) / 100;
            } else if (pairEl.id === 'height') {
                target.value = Math.round((pairMax * aspectRatio) * 100) / 100;
            }
        } else {
            pairEl.value = newValue;
        }

        if (BentoSMB.selectVariantBySize() === false) {
            BentoSMB.calculatePricing();
        }

        if (BentoSMB.state === 'custom') return;
        document.querySelector('div#custom-size-fields input[type="radio"][value="custom"]')?.click();
    },
    updateProductFormScene: (event) => {
        const target = event.target;

        BentoSMB.state = target.value;
        BentoSMB.update();
    },
    updateAddToCartButtons: () => {
        // Not product page, do not proceed
        if (isEnterprise === undefined) return;

        // Update text
        BentoSMB.elements.addToCart.children.label.innerHTML = 'Proceed to Cart';

        const reloadButtonEl = BentoSMB.elements.addToCart.cloneNode(true);
        reloadButtonEl.setAttribute('data-no-redirect', '');
        reloadButtonEl.children.label.innerHTML = 'Add another transfer';

        BentoSMB.elements.addToCart.before(reloadButtonEl);
    },
    updateDraftOrder: (data, callback = () => null) => {
        console.log(data);
        let items = data.items;
        if (items === undefined) {
          console.log('no items data');
          return;
        }
      
        if (typeof data.item === 'object') {
            const cartLineIndex = cart.items.findIndex((item) => item.key === data.item.key);

            if (cartLineIndex === -1) {
                items = [...cart.items, data.item];
            } else {
                items = cart.items;
                items[cartLineIndex] = data.item;
            }
        }

        const cartDiscount = {value: 0, title: ''};
        const parsedItems = items.map(
            (item) => {
                const params = {
                    quantity: item.quantity,
                    customAttributes: Object.entries(item.properties).map(
                        ([key, value]) => ({key, value})
                    ),
                };

                if (item.sku === 'SI_ENTERPRISE_AG') {
                    params.title = item.title;
                    params.requiresShipping = item.requires_shipping;
                  
                    let pricePerUnit = item.properties['_price_per_unit'];
                    pricePerUnit = pricePerUnit ? pricePerUnit.toString().replace(/[^0-9]/g, '') : '';
                    
                    if (pricePerUnit && !isNaN(pricePerUnit)) {
                        params.originalUnitPrice = (Number(pricePerUnit) / 100).toFixed(2);
                    } else {
                        console.error("Invalid '_price_per_unit' value after cleaning:", pricePerUnit);
                        params.originalUnitPrice = 0; // Fallback value
                    }
                } else {
                    params.variantId = `gid://shopify/ProductVariant/${item.variant_id}`;
                }

                if (item.discounts.length > 0) {
                    const discount = item.discounts[0];
                    console.log(discount);
                    cartDiscount.title = discount.title;
                    cartDiscount.value += Number(discount.amount) / 100;
                    
                    // if ((/(\d+(?:\.\d*)?)%/).test(discount.title) === true) {
                    //     const percentage = discount.title.match(/(\d+(?:\.\d*)?)%/)?.[0].replace('%', '');
                    //     if (typeof percentage === 'string') {
                    //         params.appliedDiscount = {
                    //             title: discount.title,
                    //             value: Number(percentage), 
                    //             valueType: 'PERCENTAGE',
                    //         };
                    //     }
                    // } else {
                    //     params.appliedDiscount = {
                    //         title: discount.title,
                    //         value: (item.price - item.discounted_price)/100, 
                    //         valueType: 'FIXED_AMOUNT',
                    //     };
                    // }
                }
 
                return params;
            }
        );

        const requestData = {
            lineItems: parsedItems,
        };

        if (useMarkets === true) {
          requestData.marketRegionCountryCode = Shopify.country;
        }

        if (cartDiscount.value > 0) {
            requestData.appliedDiscount = {
                ...cartDiscount,
                valueType: 'FIXED_AMOUNT',
            };
        }

        const cartId = BentoSMB.getCookie('cart');
        console.log({cartId, requestData})
        $.ajax({
            type: "POST",
            url: "https://ovl6hkityta4yhfjdbr5dyvvie0cexth.lambda-url.us-east-1.on.aws",
            data: JSON.stringify(requestData),
            headers: {
                "Content-Type": "application/json",
                'Draft-Order-ID': BentoSMB.cachedDraft?.id,
                'Cart-ID': cartId,
            },
        }).done((function(data) {
          console.log({data});
            BentoSMB.setCachedDraft(data);
            callback();
        }
        )).fail((function(err) {
            console.log(err)
        }
        ));
    },
    handleRedirect: () => {
        if (BentoSMB.redirect === false) return;

        window.location.href = '/cart';
        // setTimeout(() => window.location.href = '/cart', 5000);
    },
    checkDraft: (_retry = false) => {
        if (BentoSMB.checkIfDraftRequired() === false) return;

        BentoSMB.cachedDraft = BentoSMB.getCachedDraft();

        if (typeof BentoSMB.cachedDraft === 'string') {
            BentoSMB.cachedDraft = JSON.parse(BentoSMB.cachedDraft);
            console.log('HELLOOOOOO')
            console.log(BentoSMB.cachedDraft)
            console.log('CART', cart)

            try {
                const lineItemToUpdatePricing = [];
                const subtotalPrice = cart.items.reduce((acc, item) => {
                    if (item.properties['_price_per_unit']) {
                        return acc + (Number(item.properties['_price_per_unit']) * item.quantity);
                    }
    
                    return acc + item.final_line_price;
                }, 0) / 100;

                console.log({subtotalPrice})
    
                let draftSubtotalPrice = BentoSMB.cachedDraft.lineItems.edges.reduce((acc, {node: item}) => {
                    if (item.custom === true) {
                        const setPricePer = item.customAttributes.find(attr => attr.key === '_price_per_unit')?.value;
                        
                        if (setPricePer === undefined) return acc;

                        const setPrice = Number(setPricePer) * item.quantity;                      
                        lineItemToUpdatePricing.push({
                            price: bcpo.formatMoney(Number(item.discountedTotalSet.presentmentMoney.amount) * 100, '${{ amount }}'),
                            pricePer: bcpo.formatMoney((Number(item.discountedTotalSet.presentmentMoney.amount) * 100) / item.quantity, '${{ amount }}'),
                            currentPrice: Number(setPrice) / 100,
                            currentPricePer: Number(setPricePer) / 100,
                        });

                        return acc + (Number(setPrice) / 100);
                    }
    
                    return acc + Number(item.discountedTotalSet.presentmentMoney.amount);
                }, 0);

                // Handle rounds errors for fractional cents values
                draftSubtotalPrice = Math.round(draftSubtotalPrice * 100) / 100

                console.log(subtotalPrice === Number(draftSubtotalPrice), subtotalPrice, Number(draftSubtotalPrice))
              
                if (subtotalPrice === Number(draftSubtotalPrice)) {
                    BentoSMB.injectDraft();
                    if (lineItemToUpdatePricing.length > 0) {
                        lineItemToUpdatePricing.forEach(item => {
                            const els = document.querySelectorAll(`.original_line_price, .original_price, [data-mczr="item_original_line_price-not-mczr"], [data-mczr="item_original_price-not-mczr"]`);
                            els.forEach(el => {
                                if (el.innerHTML.includes(item.currentPrice)) {
                                    el.innerHTML = item.price;
                                }
                                if (el.innerHTML.includes(item.currentPricePer)) {
                                    el.innerHTML = item.pricePer;
                                }
                            });
                        });
                    }

                    return;
                }
            } catch (err) {
                console.error(err);
            }
        } 

        if (_retry === true) {
            console.error('Failed to create draft order');
            return;
        }

        BentoSMB.updateDraftOrder(cart, () => BentoSMB.checkDraft(true));
    },
    checkIfDraftRequired: (event) => {
        const items = event?.items || cart.items;
        return items.some((item) => item.sku === 'SI_ENTERPRISE_AG');
    },
    getCachedDraft: () => {
        const cartId = BentoSMB.getCookie('cart');
        const name = `draft#${cartId}`;

        const cookies = BentoSMB.getCookiesWithId(name);

        let value = null;
        if (Object.keys(cookies).length > 0) {
          value = Object.values(cookies).reduce((acc, part) => acc + part, '');
        }
      
        return BentoSMB.inflateCachedDraft(value);
    },
    getCookie: (name) => {
        const cookieName = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }

            if (cookie.indexOf(cookieName) == 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }

        return null;
    },
    getByteSize(str) {
      return new TextEncoder().encode(str).length;
    },
    splitIntoNEqualParts(str, n) {
        const partLength = Math.floor(str.length / n);
        const remainder = str.length % n;
        
        let parts = [];
        let start = 0;
    
        for (let i = 0; i < n; i++) {
            const extra = i < remainder ? 1 : 0;
            const end = start + partLength + extra;
            parts.push(str.slice(start, end));
            start = end;
        }
    
        return parts;
    },
    setCachedDraft: (draft) => {
        const cartId = BentoSMB.getCookie('cart');
        const name = `draft#${cartId}`;

        console.log({name, draft});

        const date = new Date();
        date.setTime(date.getTime() + 2592000000); // 30 Days
        const expires = `expires=${date.toUTCString()}`;

        const value = JSON.stringify(draft);
        const compact = BentoSMB.compactCachedDraft(value);

        const byteSize = BentoSMB.getByteSize(compact);
        const splitBy = byteSize / 3000; // Where 3000 is the max byte size per cookie
        const parts = BentoSMB.splitIntoNEqualParts(compact, Math.ceil(splitBy));

        // Remove all old cookies with cartID
        const cookiesToRemove = BentoSMB.getCookiesWithId(name);
        for (const key of Object.keys(cookiesToRemove)) {
          document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
        }

        // Add new cookie
        if (parts.length > 1) {
          // Add new cookies if over max size
          for (const [index, part] of Object.entries(parts)) {
            document.cookie = `${name}[${index}]=${part};${expires};path=/`;
          }
        } else {
          document.cookie = `${name}=${compact};${expires};path=/`;
        }
    },
    getCookiesWithId(id) {
        const cookies = document.cookie.split('; ');
        const matchingCookies = {};
    
        cookies.forEach(cookie => {
            const [name, value] = cookie.split('=');
            if (name.includes(id)) {
                matchingCookies[name] = value;
            }
        });
    
        return matchingCookies;
    },
    compactCachedDraft: (value) => {
      if (typeof value !== 'string') return value;
      console.log(value
        .replace(/"id":"/g, '!a')
        .replace(/gid:\/\/shopify\/DraftOrder\//g, '!b')
        .replace(/"invoiceUrl":"https:\/\/transfergang\.com\//g, '!c')
        .replace(/\/invoices\//g, '!d')
        .replace(/"subtotalPrice":"/g, '!e')
        .replace(/"subtotalPriceSet":{/g, '!f')
        .replace(/"presentmentMoney":{/g, '!g')
        .replace(/"amount":"/g, '!h')
        .replace(/}}/g, '!i')
        .replace(/"lineItems":{/g, '!j')
        .replace(/"edges":\[/g, '!k')
        .replace(/{"node":{/g, '!l')
        .replace(/"custom":/g, '!m')
        .replace(/"quantity":/g, '!n')
        .replace(/"discountedTotalSet":/g, '!o')
        .replace(/"presentmentMoney":{"amount":"/g, '!p')
        .replace(/"customAttributes":\[/g, '!q')
        .replace(/{"key":"/g, '!r')
        .replace(/"value":"/g, '!s')
        .replace(/https:\/\/upload\.cloudlift\.app\/s\/transfer-gang\//g, '!t')
        .replace(/\.png"}/g, '!u')
        .replace(/upload_/g, '!v')
        .replace(/thumbnail_/g, '!w')
        .replace(/_height"/g, '!x')
        .replace(/_width"/g, '!y')
        .replace(/_quantity"/g, '!z')
        .replace(/_price_per_unit"/g, '!A')
        .replace(/gid:\/\/shopify\/DraftOrderLineItem\//g, '!B')
        .replace(/",/g, '!C')
        .replace(/"/g, '!D')
        .replace(/false/g, '!E')
        .replace(/true/g, '!F')
        .replace(/58501699/g, '!G'))
      return value
        .replace(/"id":"/g, '!a')
        .replace(/gid:\/\/shopify\/DraftOrder\//g, '!b')
        .replace(/"invoiceUrl":"https:\/\/transfergang\.com\//g, '!c')
        .replace(/\/invoices\//g, '!d')
        .replace(/"subtotalPrice":"/g, '!e')
        .replace(/"subtotalPriceSet":{/g, '!f')
        .replace(/"presentmentMoney":{/g, '!g')
        .replace(/"amount":"/g, '!h')
        .replace(/}}/g, '!i')
        .replace(/"lineItems":{/g, '!j')
        .replace(/"edges":\[/g, '!k')
        .replace(/{"node":{/g, '!l')
        .replace(/"custom":/g, '!m')
        .replace(/"quantity":/g, '!n')
        .replace(/"discountedTotalSet":/g, '!o')
        .replace(/"presentmentMoney":{"amount":"/g, '!p')
        .replace(/"customAttributes":\[/g, '!q')
        .replace(/{"key":"/g, '!r')
        .replace(/"value":"/g, '!s')
        .replace(/https:\/\/upload\.cloudlift\.app\/s\/transfer-gang\//g, '!t')
        .replace(/\.png"}/g, '!u')
        .replace(/upload_/g, '!v')
        .replace(/thumbnail_/g, '!w')
        .replace(/_height"/g, '!x')
        .replace(/_width"/g, '!y')
        .replace(/_quantity"/g, '!z')
        .replace(/_price_per_unit"/g, '!A')
        .replace(/gid:\/\/shopify\/DraftOrderLineItem\//g, '!B')
        .replace(/",/g, '!C')
        .replace(/"/g, '!D')
        .replace(/false/g, '!E')
        .replace(/true/g, '!F')
        .replace(/58501699/g, '!G');
    },
    inflateCachedDraft: (value) => {
      if (typeof value !== 'string') return value;
      if (value.includes('"edges"') === true) {  
        return value
          .replace(/!!cl/g, 'https://upload.cloudlift.app/s/transfer-gang/')
          .replace(/!!gd/g, 'gid://shopify/DraftOrder/')
          .replace(/!!gl/g, 'gid://shopify/DraftOrderLineItem/')
          .replace(/!!u/g, 'upload_')
          .replace(/!!t/g, 'thumbnail_')
          .replace(/!!h/g, '_height')
          .replace(/!!w/g, '_width')
          .replace(/!!q/g, '_quantity')
          .replace(/!!p/g, '_price_per_unit');
       } else {
         return value
          .replace(/!a/g, '"id":"')
          .replace(/!b/g, 'gid://shopify/DraftOrder/')
          .replace(/!c/g, '"invoiceUrl":"https://transfergang.com/')
          .replace(/!d/g, '/invoices/')
          .replace(/!e/g, '"subtotalPrice":"')
          .replace(/!f/g, '"subtotalPriceSet":{')
          .replace(/!g/g, '"presentmentMoney":{')
          .replace(/!h/g, '"amount":"')
          .replace(/!i/g, '}}')
          .replace(/!j/g, '"lineItems":{')
          .replace(/!k/g, '"edges":[')
          .replace(/!l/g, '{"node":{')
          .replace(/!m/g, '"custom":')
          .replace(/!n/g, '"quantity":')
          .replace(/!o/g, '"discountedTotalSet":')
          .replace(/!p/g, '"presentmentMoney":{"amount":"')
          .replace(/!q/g, '"customAttributes":[')
          .replace(/!r/g, '{"key":"')
          .replace(/!s/g, '"value":"')
          .replace(/!t/g, 'https://upload.cloudlift.app/s/transfer-gang/')
          .replace(/!u/g, '.png"}')
          .replace(/!v/g, 'upload_')
          .replace(/!w/g, 'thumbnail_')
          .replace(/!x/g, '_height"')
          .replace(/!y/g, '_width"')
          .replace(/!z/g, '_quantity"')
          .replace(/!A/g, '_price_per_unit"')
          .replace(/!B/g, 'gid://shopify/DraftOrderLineItem/')
          .replace(/!C/g, '",')
          .replace(/!D/g, '"')
          .replace(/!E/g, 'false')
          .replace(/!F/g, 'true')
          .replace(/!G/g, '58501699');
       }
    },
    clearCachedDraft: () => {

    },
    injectDraft: () => {
        const cartFormEl = document.querySelector('form#cart');
        console.log('INJECTING', cartFormEl)
        if (cartFormEl !== null) {
            cartFormEl.addEventListener('submit', (event) => {
                event.preventDefault();

                window.location.href = BentoSMB.cachedDraft.invoiceUrl;
            })

            const discountInput = document.querySelector('.docapp-coupon-input.docapp-widget');
          if (discountInput !== null) {
            discountInput.style.display = 'none !important';
          }
        }
    },
    subscribe: () => {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (BentoSMB.checkIfDraftRequired(event) === true) {
                BentoSMB.updateDraftOrder(event);
            }
            BentoSMB.handleRedirect();
        });
    },
    reset: (event) => {
        try {
            if (event.submitter.hasAttribute('data-no-redirect')) {
                window.location.reload();
                return;
            }

            BentoSMB.redirect = true;
        } catch {}
    },
    init: () => {
        BentoSMB.checkDraft();
        BentoSMB.subscribe();
        BentoSMB.listen();
        BentoSMB.getElements();
        BentoSMB.updateAddToCartButtons();
    },
};

document.addEventListener("DOMContentLoaded", BentoSMB.init);